import { io } from "socket.io-client";

let socket = null;

export function getSocket() {
  if (socket && socket.connected) return socket;
  const token = localStorage.getItem("auth_token");
  if (!token) return null;
  socket = io(process.env.REACT_APP_BACKEND_URL, {
    path: "/api/socket.io",
    auth: { token },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
  });
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
